import { createReducer } from 'redux-act';
import {
    IMPORTER_START_SUCCESS,
    IMPORTER_START_FAIL,
    IMPORTER_CANCEL_SUCCESS,
    IMPORTER_CANCEL_FAIL

} from '../actions/importer';

const initialState = {
    loading: false,
    response: [],
    error: null,
    message: null
};

export const importerReducer = createReducer(
    {
        [IMPORTER_START_SUCCESS]: (state) => ({
            ...state,
            loading: true,
            error: null,
        }),
        [IMPORTER_START_FAIL]: (state, payload) => ({
            ...state,
            loading: false,
            error: payload.error,
        }),
        [IMPORTER_CANCEL_FAIL]: (state, payload) => ({
            ...state,
            loading: false,
            error: payload.error,
        }),
        [IMPORTER_CANCEL_SUCCESS]: (state) => ({
            ...state,
            loading: true,
            error: null,
        }),
    },
    initialState
);

export default importerReducer;
